import { Img } from "ui-kit/components-branded/index"
import { useClientContext } from "modules/ClientAuthorization/common/ClientContext"
import style from "modules/NewClientSurvey/components/QuestionnaireCards/components/Header/style.module.scss"
import { isVerified } from "modules/ClientAuthorization/common/utils"

export function Header() {
    const [{ userAccount }] = useClientContext()
    const title = isVerified(userAccount)
        ? `${userAccount.name}, кому подбираем психолога?`
        : "Кому подбираем психолога?"
    return (
        <div className={style.wrapper}>
            <div className={style.emoji}>
                <Img src="regular-emoji.gif" />
            </div>
            <div className={style.container}>
                <div className={style.content}>
                    <div className={style.title}>{title}</div>
                </div>
            </div>
        </div>
    )
}
